import { FC, SVGProps } from 'react';

const NewChatIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = 'white',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.53735 7.80396H10.2611M7.53735 11.5587H12.941"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 17.5C14.1422 17.5 17.5 14.1422 17.5 10C17.5 5.85787 14.1422 2.5 10 2.5C5.85787 2.5 2.5 5.85787 2.5 10C2.5 11.7908 3.12764 13.435 4.17494 14.7247C4.30014 14.8788 4.31014 15.099 4.19058 15.2576L3.30522 16.432C2.97407 16.8713 3.28745 17.5 3.83757 17.5H10Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default NewChatIcon;
